import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapStateToProps} from '../../../helpers/reselectHelpers';
import {CustomFieldModel} from '../../../models/api/customFieldModel';
import {AppState} from '../../../store/appState';
import {getCustomFields} from '../../../store/data/dataSelectors';
import {CustomFieldsTableRow} from './customFieldsTableRow';

/*
 * Props.
 */

interface CustomFieldsTableRowContainerProps {
  customFieldId: number;
  defaultCustomFields: ReadonlyArray<CustomFieldModel>;
}

/*
 * Selectors.
 */

function getCustomFieldId(_state: AppState, props: CustomFieldsTableRowContainerProps) {
  return props.customFieldId;
}

function getDefaultCustomFields(_state: AppState, props: CustomFieldsTableRowContainerProps) {
  return props.defaultCustomFields;
}

function makeGetCustomField() {
  return createSelector(
    [getCustomFieldId, getCustomFields, getDefaultCustomFields],
    (customFieldId, customFields, defaultCustomFields) => {
      const defaultCustomField = defaultCustomFields.find((customField) => customField.id === customFieldId);
      if (defaultCustomField) {
        return defaultCustomField;
      }
      return customFields[customFieldId];
    },
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CustomFieldsTableRowContainerProps>()(() => ({
  customField: makeGetCustomField(),
}));

export const CustomFieldsTableRowContainer = connect(mapStateToProps)(CustomFieldsTableRow);
